import WebComponent from '../../webComponents/WebComponent';
import flatpickr from 'flatpickr';
import RangePlugin from 'flatpickr/dist/plugins/rangePlugin';
import dateFormat  from 'date-fns/format';
import dateParse from 'date-fns/parse';

class Datepicker extends WebComponent {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleInputEvent = this.handleInputEvent.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
  }

  didMount() {
    const {
      rangeWith,
      locale,
      format,
      ...props
    } = this.props;

    const plugins = [];

    this.on('blur', this.handleInputChange);
    this.on('input', this.handleInputEvent);

    if (rangeWith != null) {
      plugins.push(new RangePlugin({ input: rangeWith }));
    }
    this.flatpickr = flatpickr(this.element, {
      ...props,
      locale: locale === 'en' ? null : locale,
      plugins,
    });

    this.flatpickr.config.onOpen.push(this.handleOpen);
    this.flatpickr.config.onClose.push(this.handleClose);

  }

  handleOpen = () => {
    this.setState({
      open: true,
    });
  };
  handleClose(e) {
    const { parseDate, dateFormat, clearInvalidDate } = this.props;
    const value = this.element.value;

    if (value) {
      const date = parseDate(value, dateFormat);
      const isValidDate = !isNaN(date);
      if (isValidDate) {
        this.flatpickr.setDate(date, false);
      }
      if (!isValidDate && clearInvalidDate) {
        this.element.value = '';
        this.flatpickr.setDate('', false);
      }
    }

    this.setState({
      open: false,
    });
  };

  willUnMount() {
    clearTimeout(this.hideTimeoutTimer);
    this.flatpickr.destroy();
  }

  handleInputEvent = (e) => {
    e.stopPropagation();
    const { value } = e.target;
    if (this.lastValue !== value && value === '') {
      this.lastValue = value;
      this.dispatchChangeEvent();
    }
  };
  handleInputChange = (e) => {
    e.stopPropagation();
  };

  update() {
    const {
      open,
    } = this.state;
    this.element.dataset.stateOpen = open;
  }
}

Datepicker.defaultProps = {
  hideTimeout: 200,
  locale: 'cs',
  allowInput: true,
  altInput: false,
  dateFormat: 'd/m/Y',
  time_24hr: true,
  minuteIncrement: 5,
  hourIncrement: 1,
  altFormat: 'd. M. yyyy',
  ariaDateFormat: 'd. M. yyyy',
  clearInvalidDate: false,
  formatDate: (date, format) => {
    return dateFormat(date, format);
  },
  parseDate: (value, format) => {
    return dateParse(value, format, new Date());
  },
};

export {
  Datepicker,
};



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/src/components/Datepicker/Datepicker.js